<template>
  <div>
    <slot name="title"></slot>

    <template v-for="item in items.slice(0, initial)">
      <slot :item="item">{{ item }}</slot>
    </template>

    <cp-expander v-if="showAll">
      <template v-for="item in items.slice(initial)">
        <slot :item="item">{{ item }}</slot>
      </template>
    </cp-expander>

    <div v-if="items.length > initial" @click="showAll = !showAll" style="margin: 3px">
      <cp-unstyled-button link v-if="!showAll"> + More {{ label }} </cp-unstyled-button>

      <cp-unstyled-button link v-if="showAll"> - Fewer {{ label }} </cp-unstyled-button>
    </div>
  </div>
</template>

<script>
import CpExpander from '../expander.vue';
import CpUnstyledButton from '../unstyled-button';

export default {
  components: {
    CpExpander,
    CpUnstyledButton,
  },

  props: {
    items: { type: Array, required: true },
    value: Array,
    initial: { type: Number, default: 3 },
    label: { type: String },
  },

  data() {
    return {
      showAll: false,
    };
  },

  watch: {
    showAll(showAll) {
      this.$emit(showAll ? 'expand' : 'collapse');
      this.$emit('change');
    },
  },
};
</script>
